const invitations = {
  pageName: 'Einladungen',

  toast: {
    error: {
      default: 'Der Vorgang konnte nicht abgeschlossen werden.',
    },
    success: {
      delete: {
        default: 'Einladung(en) erfolgreich gelöscht',
      },
      resend: {
        default: 'Einladung(en) erfolgreich erneut gesendet.',
      },
      create: {
        default: 'Erfolg! Einladung erfolgreich gesendet.',
      },
    },
  },

  table: {
    headers: {
      status: 'Status',
      email: 'E-Mail',
      role: 'Rolle',
      invitedBy: 'Eingeladen von',
    },
    actions: {
      delete: 'Löschen',
      resend: 'Erneut senden',
    },
    filters: {
      status: 'Status',
    },
  },

  form: {
    headers: {
      personalDetails: 'Persönliche Daten',
      roles: 'Benutzerrollen',
    },
    fields: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      name: 'Name',
      phone: 'Telefon',
      email: 'E-Mail',
      role: 'Rolle',
      site: 'Bereich',
      supplier: 'Anbieter',
    },
    select: 'Wählen',
    buttons: {
      addAccess: 'Bereich hinzufügen',
      sendInvitation: 'Einladung senden',
    },
  },

  deleteModal: {
    header: 'Einladungen löschen',
    body: 'Sie sind dabei, {{num}} Einladungen zu löschen.',
  },

  resendModal: {
    header: 'Einladungen erneut senden',
    body: 'Sie sind dabei, {{num}} Einladungen erneut zu versenden.',
  },

  inviteModal: {
    header: 'Benutzer einladen',
    description: {
      new: 'Bitte geben Sie die E-Mail-Adresse ein und wählen Sie die gewünschten Rollen aus.',
      existing: 'Bitte wählen Sie Standorte und bevorzugte Rollen aus.',
    },
  },

  status: {
    pend: 'Ausstehend',
    accepted: 'Akzeptiert',
    expired: 'Abgelaufen',
  },

  isCompanyAdmin: 'Firmenadministrator',
};

export default invitations;
